import { collection, getDocs } from "firebase/firestore";
import { Collections, db } from "../../utils/firebase.config";
import { converterOf } from "../../utils/firebase.utils";
import Cleaning from "../../entities/cleaning.entity";

export function useCleanings() {
  const cleaningsCollection = collection(db, Collections.Cleanings).withConverter(converterOf(Cleaning));

  const fetchAll = async (): Promise<Cleaning[]> => {
    const response = await getDocs<Cleaning>(cleaningsCollection);

    return response.docs.map((cleaning) => cleaning.data());
  };

  return { fetchAll };
}

export default useCleanings;
